
















import { EntityStatus, Fault, FeedTank } from '@/api';
import { Component, InjectReactive, Prop, Vue, Watch } from 'vue-property-decorator';
import { FeedProduct } from '../models';

import WarningIcon from '@/components/display/warning-icon.vue';
import { ProductStatusService } from '@/services/product-status-service';

@Component({
	components: {
		WarningIcon,
	},
})
export default class FeedProductTabBar extends Vue {
	@InjectReactive('feedProduct')
	private feedProduct!: FeedProduct;

	@Prop({ required: true, type: Boolean })
	public jobsExist!: boolean;

	private productStatusService: ProductStatusService<FeedTank> = new ProductStatusService<FeedTank>(
		this.feedProduct,
	);

	@Watch('feedProduct')
	public watchFeedProduct(): void {
		this.productStatusService = new ProductStatusService<FeedTank>(this.feedProduct);
	}

	public get navLinks(): {
		url: string;
		linkTitle: string;
		showWarning?: boolean;
		tooltip?: string;
		params?: { [key: string]: string };
	}[] {
		return [
			{ url: 'products.feed.general', linkTitle: 'General' },
			{ url: 'products.feed.partnerorgs', linkTitle: 'Partner Orgs' },
			{
				url: this.firstLiveTankId
					? 'products.feed.feedtanks.tankdetail'
					: 'products.feed.feedtanks',
				params: this.firstLiveTankId ? { feedTankId: this.firstLiveTankId } : undefined,
				linkTitle: 'Feed Tanks',
				showWarning: this.productStatusService.hasEntitiesTabTooltip(this.feedProduct.feedtanks),
				tooltip: this.productStatusService.getEntitiesTabTooltip(
					'Feed Tanks',
					this.feedProduct.feedtanks,
				),
			},
			{ url: 'products.feed.transceivers', linkTitle: 'Transceivers' },
			{ url: 'products.feed.users', linkTitle: 'Users' },
			{ url: 'products.feed.map', linkTitle: 'Map' },
			{ url: 'products.feed.faults', linkTitle: 'Faults', showWarning: this.activeFaults },
			{ url: 'products.feed.simprojobs', linkTitle: 'Simpro Jobs', showWarning: this.jobsExist },
			{ url: 'products.feed.repairjobtexts', linkTitle: 'Repair Job Texts' },
			{ url: 'products.feed.smscharges', linkTitle: 'SMS Charges' },
		];
	}

	public get activeFaults(): boolean {
		return this.feedProduct.faults.some((fault: Fault) => fault.status !== 'resolved');
	}

	private get firstLiveTankId(): string | null {
		const firstLiveTank = this.feedProduct.feedtanks.find(
			(feedTank: FeedTank) => feedTank.status === EntityStatus.Live,
		);
		if (firstLiveTank && firstLiveTank.id) {
			return firstLiveTank.id.toString();
		}
		return null;
	}
}
